import React from "react";

import CardSlider from "./CardSlider";
import User1Image from "./assets/img/entrygate1.png";
import User3Image from "./assets/img/entrygate3.png";
import User4Image from "./assets/img/user4.png";
import User2Image from "./assets/img/entrygate2.png";

const EntryGateSlider = ({ backgroundColor }) => {
  const cardData = [
    {
      title: "Step 1",
      imageSrc: User1Image,
      heading: "Visitor Entry",
      subheading:
        " Upon arrival at the designated premises, visitors present the Digipass PDF, containing the QR code, to the e-gate machine for entry verification. ",
    },
    {
      title: "Step 2",
      imageSrc: User2Image,
      heading: "QR Code Verification",
      subheading:
        " The e-gate machine scans and verifies the QR code on the Digipass PDF to determine the validity of the visitor's appointment...",
    },
    {
      title: "Step 3",
      imageSrc: User3Image,
      heading: "Face Match Verification",
      subheading:
        "As an added layer of security, the e-gate machine captures an image of the visitor's face. It performs a face match comparison between the captured... ",
    },
    {
      title: "Step 4",
      imageSrc: User4Image,
      heading: "Entry Verification",
      subheading:
        "Alternatively, visitors who choose the form option fill in the required details, including personal information and appointment preferences.... ",
    },
  ];

  const heading = <div>Entry Gate User Journey</div>;

  return (
    <CardSlider
      cardData={cardData}
      heading={heading}
      backgroundColor={backgroundColor}
    />
  );
};

export default EntryGateSlider;
